<template>
  <vl-map
    class="vlmap"
    ref="map"
    :load-tiles-while-animating="true"
    :load-tiles-while-interacting="true"
    data-projection="EPSG:4326"
    @mounted="onMapMounted"
    @pointermove="onMapPointerMove"
    :style="{cursor: mapCursor}"
    @singleclick="i++, clickCoord = $event.coordinate"
   >
    <vl-view
      :center.sync="mapViewConf.center"
      :zoom.sync="mapViewConf.zoom"
      :min-zoom.sync="mapViewConf.minZoom"
      :max-zoom.sync="mapViewConf.maxZoom"
      :rotation.sync="mapViewConf.rotation"
    ></vl-view>

    <vl-layer-tile id="osm">
      <vl-source-osm></vl-source-osm>
    </vl-layer-tile>

    <vl-interaction-select :features.sync="selected">
      <vl-style-box>
        <vl-style-icon
          src="https://img.icons8.com/office/50/000000/place-marker.png"
          :scale="0.7"
          :anchor="[0.5, 1]"
        ></vl-style-icon>
      </vl-style-box>
    </vl-interaction-select>

    <vl-layer-vector>
      <vl-source-vector :features.sync="schools">
        <vl-style-box>
          <vl-style-icon
            src="https://img.icons8.com/office/50/000000/place-marker.png"
            :scale="0.7"
            :anchor="[0.5, 1]"
          ></vl-style-icon>
        </vl-style-box>
      </vl-source-vector>
    </vl-layer-vector>

    <vl-overlay
      v-if="selected.length > 0"
      :key="i"
      :position="clickCoord"
      style="background: white; padding: 10px; position: absolute; left: -50px; bottom: 12px;"
    >
      <span class="subheading">
        {{ selected[0].properties.name }}
      </span>
    </vl-overlay>
  </vl-map>
</template>

<script>
  import Vue from 'vue'
  import VueLayers from 'vuelayers'
  import 'vuelayers/lib/style.css' // needs css-load:querySelector('query')er
  import { findPointOnSurface } from 'vuelayers/lib/ol-ext'

  import ScaleLine from 'ol/control/ScaleLine'
  import ZoomSlider from 'ol/control/ZoomSlider'

  Vue.use(VueLayers)

  // Datos de la aplicación
  import schoolsData from './../data/schools'

  export default {
    name: 'Map',

    created () {
      this.computeCenter()
    },

    data: function() {
      return {
        mapViewConf: {
          center: [-76.54428138066408,3.372536785418347],
          zoom: 13,
          minZoom: 10,
          maxZoom: 19,
          rotation: 0
        },
        selected: [],

        schools: schoolsData,
      }
    },

    watch:{
      selected: function () {
        if (this.selected.length > 0){
          this.$store.commit('selected_school', this.selected[0])
        }
      }
    },

    methods: {
      pointOnSurface: findPointOnSurface,

      onMapMounted () {
        this.$refs.map.$map.getControls().extend([
          new ScaleLine(),
          new ZoomSlider()
        ])
      },
      computeCenter () {
        let lon = []
        let lat = []

        this.schools.forEach(function (element) {
          lon.push(element.geometry.coordinates[0].toString())
          lat.push(element.geometry.coordinates[1].toString())
        })
        lon.sort()
        lat.sort()

        // Selecciona el valor central de latitud y longitud
        this.mapViewConf.center[0] = parseFloat(lon[Math.trunc(lon.length / 2)])
        this.mapViewConf.center[1] = parseFloat(lat[Math.trunc(lat.length / 2)])

        this.mapkey += 1
        this.loading = false
      }
    }
  }
</script>

<style>
  .vlmap {
    overflow:hidden;
    background:none!important;
    height:100%;
    width:100%;
  }
</style>
